/*
  INSERT INTO _61rs (
    _dmn,
    _61r_31r1f, 
    _key, _vsn, _ltt, _fst, 
    _icn, 
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 
    1,
    1, 1, 1, 1, 
    '2022', 
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _611s (
    _dmn, 
    _611_31r1f, 
    _key, _vsn, _ltt, _fst, 
    _611_61r1k, _icn, 
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 
    1,
    1, 1, 1, 1, 
    1, '2022-11-29',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );
*/

export const _61z = { // 休日（ドメイン別）
  _61r: { // 年
    v0: {
      itlz: {
        _61r_31r1f: -1,
      },
      fldz: {
        _61r_31r1f: {
          pfx: '部門'
        },
        _icn: {
          pfx: '年'
        }
      },
    },
  },
  _611: { // 休日
    v0: {
      itlz: {
        _611_31r1f: -1,
        _611_61r1k: -1,
        _icn: '',
        _611a3100s: '',
      },
      fldz: {
        _611_31r1f: {
          pfx: '部門'
        },
        _611_61r1k: {
          pfx: '年'
        },
        _icn: {
          pfx: '日付',
        },
        _611a3100s: {
          pfx: '外部連携予約ID(json形式)',
        },
      },
    },
  },
};
